angular.module( 'acme.view.application.programs.modals.rescheduleEvent', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.programs.modals.rescheduleEvent.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsModalsRescheduleEvent = {
        name: 'application.programs.modals.rescheduleEvent',
        url: '/programs/modals/rescheduleEvent',
        views: {
          "main": {
            controller: 'ProgramsModalsRescheduleEventController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/modals/rescheduleEvent/rescheduleEvent.tpl.html'
          }
        },
        data: {
          pageTitle: '   ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(programsModalsRescheduleEvent);
});
